<template>
  <v-card class="pt-4">
    <v-card-text class="mb-3">
      <v-row row-gutters>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter table data."
            single-line
            hide-details
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-data-table
      fixed-header
      height="55vh"
      :search="search"
      :headers="headers"
      :items="matchedsanctionsdata"
      :items-per-page="10"
      dense
    >
    </v-data-table>

    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </v-card>
</template>

<script>
import commonService from "@/services/CommonService/commonService.js";
import Loading from "vue-loading-overlay";
export default {
  name: "sanction Matched",
  components: {
    Loading,
  },
  data: () => ({
    search: "",
    loader: false,
    headers: [
      {
        text: "SDN.no",
        value: "ofacKey",
        sortable: false,
      },

      { text: "Name", value: "name", sortable: false },
      { text: "Address", value: "address", sortable: false },
      { text: "Type", value: "vessel_type", sortable: false },
      { text: "Remarks", value: "remarks", sortable: false },
    ],
    matchedsanctionsdata: [],
  }),

  mounted() {
    this.opensanctions();
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async opensanctions() {
      this.loader = true;

      try {
        const response = await commonService.getcompliancematchedsanctions(
          this.$route.query.customerid
        );
        if (response.status === 200) {
          this.matchedsanctionsdata = response.data.data;
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("countryOptions", this.matchedsanctionsdata);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.matchedsanctionsdata = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.bgprimary {
  background-color: $primary;
}
</style>
